<template>
	<el-popover placement="bottom" :width="appearList ? 920 : 600" trigger="hover" @show="show=true">
		<div class="asin-data-box" v-if="show">
			<el-card shadow="never" class="main-image-div el-card-20221212">
				<el-badge  type="warning" :value="asinInfo.rank" :hidden="!showRank">
					<el-image :src="asinInfo.product_image || (asinInfo.imgs ? asinInfo.imgs[0] : '')" fit="contain"
						style="width:250px;height: 250px"></el-image>
				</el-badge>
			</el-card>

			<div class="asin-info-div">
				<!-- <div class="product-title overflow-three-line">
					<span v-if="asinInfo.title">{{ asinInfo.title }}</span>
					<span v-else class="no-data-font-1"></span>
				</div> -->
				<div class="product-title overflow-two-line">
					<el-tooltip effect="light" placement="top" :content="'在亚马逊中打开'">
						<a target="_blank" :href="'https://www.'+ getCountryObjByCity(country).department +'/dp/' + asinInfo.asin + '?&_encoding=UTF8&tag=yuzone00-20&linkCode=ur2&linkId=9dc4a4f9e26ed16b3d10606d082063f2&camp=1789&creative=9325'">
							{{ asinInfo.title }}
						</a>
					</el-tooltip>
				</div>

				<div class="asin-top-data">
					<!--				asin-->
					<div style="margin-left: 3px;">
						<copy-sub placement="top" v-if="clickType === 'copy'" :value="asinInfo.asin " content="点击复制">
							<a class="underline-dashed-line" style="margin-right: 5px;">{{ asinInfo.asin }}</a>
						</copy-sub>

						<el-tooltip v-else effect="light" placement="top" :content="'点击查询该ASIN相关的关键词的数据'">
							<a class="underline-dashed-line" style="margin-right: 5px;" @click="click_asin()">{{ asinInfo.asin }}</a>
						</el-tooltip>

						<el-tooltip v-if="clickType === 'copy'" effect="light"
							placement="top" :content="'点击查询该ASIN相关的关键词的数据'">
							<i class="el-icon-search" @click="click_asin()" style="font-weight: bolder;cursor: pointer"></i>
						</el-tooltip>
						<copy-sub v-else :value="asinInfo.asin"></copy-sub>


						<el-tooltip effect="light" placement="top" :content="'点击发送去获取获取最新ASIN数据'">
							<refresh-sub style="margin-left: 2px" :asin="asinInfo.asin" :country="country"></refresh-sub>
						</el-tooltip>

						<el-tooltip effect="light" placement="top" :content="'在亚马逊中打开'">
							<a target="_blank"
								:href="'https://www.'+ getCountryObjByCity(country).department +'/dp/' + asinInfo.asin + '?&_encoding=UTF8&tag=yuzone00-20&linkCode=ur2&linkId=9dc4a4f9e26ed16b3d10606d082063f2&camp=1789&creative=9325'"
								style="margin-left: 5px;">
								<i class="el-icon-paperclip"></i>
							</a>
						</el-tooltip>
					</div>
					<!--				跳转连接-->
					<!-- <div style="margin: 10px 0"> -->
						<!-- <a target="_blank" :href="'/index/traffic_source?asin=' + asinInfo.asin + '&country=' + country" >
							<el-tag type="warning" size="mini">查流量来源</el-tag>
						</a>

						<a target="_blank" style="margin-left: 4px"
							:href="'/index/reverse?asin=' + asinInfo.asin + '&country=' + country" >
							<el-tag type="warning" size="mini">反查流量词</el-tag>
						</a> -->

						<!-- <a target="_blank"  style="margin-left: 4px"
							:href="'https://www.zi4.com/dp/' + asinInfo.asin">
							<el-tag type="warning" size="mini">评论分析</el-tag>
						</a>
						<a target="_blank" style="margin-left: 4px"
							:href="'https://www.chazhanwai.com/?q=' + asinInfo.asin + '&country=' + country" >
							<el-tag type="warning" size="mini">站外分析</el-tag>
						</a> -->
					<!-- </div> -->
					<!--				上架时间-->
					<el-row :gutter="10">
						<el-col :span="15">
							<el-rate class="el-rate-20221208" v-model="asinInfo.score" disabled
								:colors="colors"></el-rate>
							<font size="2" color="#409eff">
								{{ toThousands(asinInfo.commentNum) }}
							</font>
						</el-col>
						<el-col :span="9">
							<div v-if="asinInfo.uploadTime">
								<!-- 上架时间: -->
								<span style="float: right;">
									{{ $timezone(asinInfo.uploadTime, 'yyyy-MM-DD') }}
								</span>
							</div>
						</el-col>
					</el-row>
				</div>

				<div style="line-height: 22px;" >
					<div>
						<font v-if="asinInfo.price" style="font-weight: bolder;" color="#F56C6C" size="4">
							{{ asinInfo.price }}
						</font>
						<font size="4" v-else> -- </font>
					</div>

					<div>
						品牌:
						<el-tooltip effect="light" :content="asinInfo.brand" placement="top-end">
								<span v-if="asinInfo.brand">
									{{ asinInfo.brand }}
								</span>
							<font v-else> -- </font>
						</el-tooltip>
					</div>
					<div class="overflow-one-line" style="width:250px">
						卖家:
						<el-tooltip v-if="asinInfo.seller"
							effect="light" :content="asinInfo.seller" placement="top-end">
								<span >
									{{ asinInfo.seller }}

									<font style="font-weight: bolder;" v-if="asinInfo.distributionMode">
										({{ asinInfo.distributionMode }})
									</font>
								</span>
						</el-tooltip>
						<font v-else> -- </font>
					</div>
					<div class="share-box-div" v-if="asinInfo.click_share">
						<div v-if="asinInfo.click_share">
							<div>
								点击占比:
								<font class="font-weight">
									{{ toPercent(asinInfo.click_share,2) }}
								</font>
							</div>
							<div>
								转化占比:
								<font class="font-weight">
									{{ toPercent(asinInfo.conversion_share,2) }}
								</font>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div style="width: 340px;margin-left: 20px;border-left: 1px solid #DCDFE6;padding-left: 10px"
				v-if="appearList">
				<el-table :data="appearList" max-height="275px">
<!--					<el-table-column type="index" width="50" label="#" align="center">-->
<!--						<template slot-scope="scope">-->
<!--							<span class="no-data-font">{{ scope.$index }}</span>-->
<!--						</template>-->
<!--					</el-table-column>-->
					<el-table-column label="日期" width="210px"  align="center">
						<template slot="header">
							日期 <span class="emphasis-hint" v-if="appearList">({{ appearList.length }})</span>
						</template>
						<template slot-scope="scope">{{  fomatTimeStr(scope.row.date) }}</template>
					</el-table-column>
					<el-table-column label="点击转化" width="80px" align="center" header-align="center">
						<template slot-scope="scope">
							<div style="font-size: 12px; line-height: 16px; text-align: right;">
								<div>{{ toPercent(scope.row.click_share,2) }}</div>
								<div>{{ toPercent(scope.row.conversion_share,2) }}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="排名" width="50px" align="center">
						<template slot-scope="scope">{{ scope.row.keywordsRank }}</template>
					</el-table-column>
				</el-table>

			</div>
		</div>

		<slot slot="reference"></slot>
	</el-popover>
</template>

<script>
import COPY_SUB from "@/components/template/otherSub/copySub";
import { getCountryObjByCity } from "@/components/config/countryCodeConfig";
import { toThousands, changeDecimal, toPercent } from "@/components/common/utils/fomatNum";
import { fomatTimeStr } from "@/components/common/utils/time";
import REFRESH_ASIN_SUB from "@/components/template/view/sub/asin/refreshAsinData";

export default {
	name: "asinInfoPopoverSub",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER'],
	data() {
		return {
			show: false,
			clickType: localStorage.getItem("weeklyClickType"),
			colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
		}
	},
	props: {
		showRank : {
			default: true
		},
		asinInfo: {
			required: true
		},
		country: {
			default: 'US'
		},
		appearList : {}
	},
	computed: {
		avgConversion(){
			return changeDecimal(this.asinInfo.conversion_share / this.asinInfo.click_share, 2)
		}
	},
	components: {
		'copy-sub': COPY_SUB,
		'refresh-sub' : REFRESH_ASIN_SUB
	},
	methods: {
		click_asin : function() {
			window.open('/index/weekly_keyword' + '?searchType=asin&searchTerm=' + this.asinInfo.asin +
				'&country=' + this.country)
		},
		getCountryObjByCity: function(c) {
			return getCountryObjByCity(c)
		},toPercent : function(n,v=2) {
			return toPercent(n,v)
		},
		changeDecimal: function(v, d) {
			return changeDecimal(v, d)
		},
		fomatTimeStr: function(date) {
			return fomatTimeStr(date)
		},
		toThousands: function(v) {
			return toThousands(v)
		},
	}
}
</script>

<style scoped>
.asin-data-box {
	display: flex;
}

.main-image-div {
	margin-right: 15px;
}

.asin-info-div {
	flex: 1;

}
.asin-top-data {
	border-bottom: 1px solid #DCDFE6;
	padding-bottom: 10px;
	margin-bottom: 10px;
}
.asin-info-div > div:not(.asin-info-div > div:first-child) {
	margin-top: 5px;
}

.asin-info-div .product-title {
	font-weight: bolder;
	overflow-x: hidden;
}

.asin-info-div  .ratings-span {
	margin-left: 10px
}

.asin-info-div  .bottom-value-div {
	border-top: 1px solid #E4E7ED;
	padding-top: 10px;
	line-height: 24px;
}
.share-box-div {
	margin-top: 10px;
	padding-top: 10px;
	border-top: 1px solid #DCDFE6;
}
</style>
<style>
.el-card-20221212 > .el-card__body{
	padding: 15px 10px 0 10px;
}
.el-rate-20221208 {
	float: left;
	margin-right: 5px;
}

.el-rate-20221208 .el-rate__icon {
	margin: 0;
}
</style>